"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.styles = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactTransitionGroup = require("react-transition-group");

var _isLoading = _interopRequireDefault(require("./helpers/isLoading"));

var _isNormal = _interopRequireDefault(require("./helpers/isNormal"));

var _isError = _interopRequireDefault(require("./helpers/isError"));

var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));

var _Error = _interopRequireDefault(require("../views/Error"));

var _classnames = _interopRequireDefault(require("classnames"));

var _withStyles = _interopRequireDefault(require("@material-ui/core/styles/withStyles"));

var _defineStyles = require("@sift/skipper/styles/defineStyles");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var TRANSITION_TIMING = 250;

function isEmpty(status) {
  if (typeof status === 'number') return false;
  return status.isEmpty();
}

function statusIsEqual(a, b) {
  if (typeof a === 'number' || typeof b === 'number') return a === b;
  return a.value === b.value;
}

var styles = (0, _defineStyles.defineStyles)(function (theme) {
  return {
    root: {},
    overlay: {
      backgroundColor: 'none',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      transition: "opacity ".concat(TRANSITION_TIMING, "ms"),
      zIndex: theme.zIndex.loader
    },
    overlayTransparent: {
      backgroundColor: 'rgba(255, 255, 255, 0.7)'
    },
    appear: {
      opacity: 0
    },
    appearActive: {
      opacity: 1
    },
    enter: {
      opacity: 0
    },
    enterActive: {
      opacity: 1
    },
    exit: {
      opacity: 1
    },
    exitActive: {
      opacity: 0
    }
  };
});
exports.styles = styles;

var Loader = /*#__PURE__*/function (_React$Component) {
  _inherits(Loader, _React$Component);

  var _super = _createSuper(Loader);

  function Loader() {
    _classCallCheck(this, Loader);

    return _super.apply(this, arguments);
  }

  _createClass(Loader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (process.env.NODE_ENV !== 'production') {
        if (this.props.isEmptyView) {
          console.warn('`isEmptyView` is deprecated.');
        }
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return (0, _isNormal["default"])(this.props.status) || (0, _isNormal["default"])(nextProps.status) || !statusIsEqual(this.props.status, nextProps.status);
    }
  }, {
    key: "renderStateView",

    /**
     * Renders the proper state view from the current status. See contents of function to
     * determine priority order of each state.
     */
    value: function renderStateView() {
      var _this$props = this.props,
          status = _this$props.status,
          isEmptyView = _this$props.isEmptyView,
          isLoadingView = _this$props.isLoadingView,
          isErrorView = _this$props.isErrorView;
      if ((0, _isLoading["default"])(status)) return isLoadingView;
      if (isEmpty(status)) return isEmptyView;
      if ((0, _isError["default"])(status)) return isErrorView;
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          classes = _this$props2.classes,
          children = _this$props2.children,
          status = _this$props2.status,
          isEmptyView = _this$props2.isEmptyView,
          isLoadingView = _this$props2.isLoadingView,
          isErrorView = _this$props2.isErrorView,
          rootRef = _this$props2.rootRef,
          rest = _objectWithoutProperties(_this$props2, ["className", "classes", "children", "status", "isEmptyView", "isLoadingView", "isErrorView", "rootRef"]);

      var stateView = this.renderStateView();
      var visible = !!stateView;
      return /*#__PURE__*/_react["default"].createElement("div", _extends({
        className: (0, _classnames["default"])(classes.root, className),
        ref: rootRef
      }, rest), /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.CSSTransition, {
        classNames: this.transitionClasses,
        timeout: this.transitionTimeout,
        appear: true,
        unmountOnExit: true,
        "in": visible
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])(classes.overlay, _defineProperty({}, classes.overlayTransparent, (0, _isNormal["default"])(status)))
      }, stateView)), (0, _isNormal["default"])(status) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, typeof children === 'function' ? children() : children));
    }
  }, {
    key: "transitionClasses",
    get: function get() {
      var classes = this.props.classes;
      return {
        appear: classes.appear,
        appearActive: classes.appearActive,
        enter: classes.enter,
        enterActive: classes.enterActive,
        exit: classes.exit,
        exitActive: classes.exitActive
      };
    }
  }, {
    key: "transitionTimeout",
    get: function get() {
      var transitionTimeout = this.props.transitionTimeout;
      return transitionTimeout || {
        enter: TRANSITION_TIMING,
        exit: TRANSITION_TIMING,
        active: TRANSITION_TIMING
      };
    }
  }]);

  return Loader;
}(_react["default"].Component);

_defineProperty(Loader, "defaultProps", {
  isLoadingView: /*#__PURE__*/_react["default"].createElement(_CircularProgress["default"], null),
  isErrorView: /*#__PURE__*/_react["default"].createElement(_Error["default"], null),
  isEmptyView: null
});

var LoaderWithStyles = (0, _withStyles["default"])(styles, {
  name: 'SkpLoader'
})(Loader); // make it so that `ref` gets passed to the root

var _default = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(LoaderWithStyles, _extends({
    rootRef: ref
  }, props));
});

exports["default"] = _default;